(() => {
  const openDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };
  const closeDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-quick-view-open]');
    if (opener) {
      event.preventDefault();
      openDialog(document.getElementById(opener.getAttribute('aria-controls')));
      return;
    }
    const closer = event.target.closest('[data-quick-view-close]');
    if (closer) closeDialog(closer.closest('dialog'));
  });
  document.addEventListener('click', (event) => {
    if (event.target.matches('dialog.quick-view')) closeDialog(event.target);
  });
})();
